export default "__VITE_ASSET__DYAjajvL__"